import { Box, Container, Flex, Text } from '@chakra-ui/react';
import React from 'react';

const Overview = () => (
  <Box px={{ xs: '25px', md: '50px' }}>
    <Container
      maxW="container.lg"
      borderColor="#fff"
      transform={{
        xs: 'translateY(-16px)',
        lg: 'translateY(-35px)',
        xl: 'translateY(-60px)',
      }}
      zIndex="30"
      boxShadow="xl"
      bg="white"
    >
      <Box padding={{ xs: '50px 15px', md: '30px 50px 56px' }}>
        <Flex flexDirection="column">
          <Text
            fontWeight="700"
            fontSize={{ xs: '26px', md: '36px' }}
            lineHeight="130%"
            color="#197542"
            textAlign="center"
            mb="2rem"
            pl="10px"
          >
            Overview
          </Text>
          <Text
            fontWeight="600"
            fontSize={{ xs: '14px', md: '24px' }}
            lineHeight="150%"
            mb="2rem"
            letterSpacing="0.02em"
            color="#010E04"
          >
            India&apos;s pivotal role in the global effort to address carbon
            emissions and climate change cannot be overstated. Achieving the
            necessary reductions requires substantial investment, potentially
            trillions of dollars over the coming decades. For such investments
            to materialize, industries must achieve economic viability,
            necessitating close collaboration with policymakers to create
            effective market frameworks.
          </Text>
          <Text
            fontWeight="400"
            fontSize={{ xs: '14px', md: '18px' }}
            lineHeight="150%"
            mb="1rem"
            letterSpacing="0.02em"
            color="#46564A"
          >
            IVCA GreenReturns Summit aims to serve as a crucial crucible for
            facilitating dialogues and interactions for climate finance to find
            the appropriate investments. The Summit will provide an excellent
            forum for conducting multiple side meetings with diverse investors
            and policymakers, further enhancing collaborative opportunities and
            strategic partnerships.
            <br />
            <br />
            The initiative is poised to become a major annual event, attracting
            hundreds of delegates, including global North investors, domestic
            and international PE/VC/credit/infra funds, portfolio companies,
            policymakers, academics, and other key stakeholders from the climate
            finance community.
          </Text>
        </Flex>
      </Box>
    </Container>
  </Box>
);

export default Overview;
